/**
 * @param s A serialized date as returned from the API
 * @returns A date if the format could be parsed
 */
export const apiDateToDate = (s: string): Date|null => s
    ? new Date(Date.parse(s))
    : null;

/**
 * Consistent formatting for a dates
 */
export const toLocaleDateString = (date: Date, locale: string|string[]|undefined = undefined): string =>
    date.toLocaleDateString(locale, {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    });

/**
 * Adds leading 0 to numbers < 10
 */
const padNr = (n: number): string =>
    n < 10 ? '0' + n : '' + n;

/**
 * Formats the time of a date as HH:ii
 */
export const toLocaleTime = (date: Date): string =>
    [ date.getHours(), date.getMinutes() ].map(padNr).join(':');
